import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {GamePlayPcHeaderBarFullScreenButtonBox} from "../../boxes/full-screen-button/game-play-pc-header-bar-full-screen-button.box";
import React from "react";
import {observer} from "mobx-react";
import {CyClass} from "../../../../../../../../common/cy-classes";

export const GamePlayPcHeaderBarFullScreenButtonComponent = observer(
    class GamePlayPcHeaderBarFullScreenButtonComponent extends OrbitComponent {
        private _onClickHandler = () => {
            if(this.services.dom.isInFullScreen) {
                this.services.dom.exitFullScreen();
            } else {
                this.services.dom.enterFullScreen();
            }
        }
        render() {
            return (
                <GamePlayPcHeaderBarFullScreenButtonBox isInFullScreen={this.services.dom.isInFullScreen}
                                                        onClick={this._onClickHandler}
                                                        className={CyClass('cy-game-navbar-fullscreen-button')}/>
            );
        }
    }
);